import { ConsumoDashboardDto } from "../typings";
import { useQuery } from "react-query";
import http from "infra/http";

export function useConsumoDashboard(consumoId?: string) {
  return useQuery(
    `/v1/consumo/${consumoId}/dashboard`,
    async () => {
      const { data } = await http.get<ConsumoDashboardDto>(
        `/v1/consumo/${consumoId}/dashboard`
      );

      return data;
    },
    {
      enabled: !!consumoId,
    }
  );
}
